import { useEffect, useState } from "react";

export function AvailabilityIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return (
    <span title={online ? "En ligne" : "Hors ligne"} style={{
      width: 10, height: 10, borderRadius: "50%",
      background: online ? "#7fe07f" : "#ff6b6b", display: "inline-block",
    }} />
  );
}
